import { PlainModal } from '@upright/ui/common/generic/modals/plain-modal';
import { useCarouselContext } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { useGetLensAndSetter } from '@upright/ui/views/model-entity-views/shared/impact-lenses/use-get-lens-and-setter';
import { ReactNode, CSSProperties } from 'react';
import styled from 'styled-components';

interface Props {
  maxWidth: number;
  children: ReactNode;
}

// OA: These will be the id's of the modal parent containers.
// Change this to return a ref if we change PlainModal's parent attachment
// to use refs instead of DOM node ids.
export function getInfoBoxModalId(lensType: ImpactLensType) {
  return `lens-${lensType}-info-box`;
}

export function ModalInfoBoxWrap(props: Props) {
  const { lens } = useGetLensAndSetter();
  // const maxWidth = props.maxWidth * 1.2;
  const context = useCarouselContext();
  const inCurrent = context.lensType === lens;
  const id = getInfoBoxModalId(context.lensType);

  const style: CSSProperties = {
    marginTop: 'auto',
    marginBottom: 'auto',
  };

  return (
    <PlainModal
      isOpen={inCurrent}
      exit="down"
      modalId={id}
      accessibleName="Details"
      hideCloseButton={true}
      closeModal={() => undefined}
      doNotCreateModalParent={true}
      style={style}
    >
      <Main>{props.children}</Main>
    </PlainModal>
  );
}

const Main = styled.div`
  width: 100%;
  max-width: min(25em, 90vw);
`;
